import * as queryKeys from "@/data/constant/queryKeys";
import { request } from "@/util/api";
import { useQuery } from "@tanstack/react-query";

const useCompanyData = (search?: any, enabled?: boolean) => {
  return useQuery<any[]>({
    queryKey: [queryKeys.COMPANY_DATA, search],
    queryFn: () => request({ method: "GET", url: `/company`, params: search }),
    enabled: enabled,
  });
};

export default useCompanyData;
